/* ============================================================
   IKON KATEGORI MARKETPLACE  —  v3.9
   ============================================================
   Tiga halaman marketplace memapar ikon kategori yang sama:
   senarai produk, halaman produk, dan Pembelian Saya.

   Peta ini duduk di sini supaya ada SATU definisi sahaja. Kalau
   ia disalin ke setiap halaman, kategori baharu yang ditambah
   kemudian akan betul di satu tempat dan salah di dua tempat lagi
   — dan kesilapan jenis itu senyap, tiada ralat yang menandakannya.

   ⚠️ Sengaja sebuah JADUAL, bukan fungsi yang memulangkan ikon.
      Pemanggil membuat capaian biasa (`IKON_KATEGORI[id]`), bukan
      panggilan fungsi semasa render — panggilan begitu ditolak oleh
      peraturan lint `react-hooks/static-components`, kerana dari
      luar ia kelihatan seperti komponen dicipta setiap kali render.

   Halaman lama (rupa sebelum v3.9) tidak menggunakan fail ini; ia
   guna nama ikon Material sendiri. Sengaja — halaman lama tidak
   disentuh supaya patah balik kekal percuma.

   Cara guna:
     const Ikon = IKON_KATEGORI[produk.category] || IKON_LAIN;
   ============================================================ */

import { BookOpen, Music2, Zap, Store } from 'lucide-react';

export const IKON_KATEGORI = {
    ebook: BookOpen,
    tiktok_account: Music2,
    flow_ultra: Zap,
};

/** Sandaran untuk kategori yang tidak dikenali — supaya UI tidak
 *  pernah kosong bila kategori baharu ditambah sebelum ikonnya
 *  dipilih. Diasingkan daripada peta supaya nama kategori sebenar
 *  tidak boleh berlanggar dengannya. */
export const IKON_LAIN = Store;
